export interface Data {
  copy: string;
  image: string;
  subcopy?: string;
}

export const data: Data[] = [
  {
    copy: `1 friend = $20 <br />Towards skincare`,
    image: '/images/rebrand/refer-image-1.svg'
  },
  {
    copy: `5 friends = $100 <br />Towards skincare`,
    image: '/images/rebrand/refer-image-2.svg'
  },
  {
    copy: `10 friends = <br />$200 + $300 bonus!`,
    image: '/images/rebrand/refer-image-3.svg',
    subcopy: `$500 towards skincare. This is a year’s worth for most of us`
  }
];
